module.exports = __webpack_public_path__ + "img/Logo.85cd4ba2.png";